<template>
  <div>
    <v-row dense class="d-flex align-center">
      <v-col cols="12" md="8" sm="8" class="d-flex align-center">
        <v-tooltip v-if="groupBy" bottom class="mx-2">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" @click="toggleGrouping" dense icon :color="groupedBy ? 'red' : 'primary'">
              <v-icon small>
                fas fa-th-list
              </v-icon>
            </v-btn>
          </template>
          <span>{{ groupedBy ? 'Quitar agrupación' : 'Agrupar' }}</span>
        </v-tooltip>
        <slot> </slot>
      </v-col>
      <!-- este vendria a ser el campo de buscado de  la  tabla al colocar el Whitsearch al comundatatablecomp ya deberia ser posible de usarlo -->
      <v-col cols="12" md="4" sm="4" class="d-flex justify-end">
        <template v-if="whitSearch">
          <v-text-field label="Buscar" dense small v-model="searchValue" :placeholder="placeholderTextsearch ? placeholderTextsearch : 'Buscar'
            " append-icon="fa-search" single-line outlined style="max-width: 400px" hide-details></v-text-field>
        </template>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <!-- esta vendia a ser la tabla y si en algun momento te dicen que quieren q solo la primera letra de las cabeceras de la  tabla sea en mayuscula, en ese caso guiarse
        de lo que estaria en el layout el cual solo es una propiedad con css y ai deberia funcionar .. en teoria ? -->
        <v-data-table :item-key="itemkey" class=" my-sticky-column-table " :class="className" dense
          :show-select="whitSelect" v-model="selectedItems" :headers="headerMayuscula"
          :group-by="groupedBy ? groupBy : []" :items="items" :search="searchValue" :items-per-page="10" :sort-by="sortBy"
          :sort-desc="sortDesc" :loading="loading" :footer-props="{
            'items-per-page-options': [10, 20, 25],
            'items-per-page-text': rowsPerPageText,
          }">
          <!-- Definir slots personalizados para las columnas -->

          <template v-slot:header>
            <slot name="customHeader"></slot>
          </template>

          <template v-slot:[`header.data-table-select`]="{ props }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-simple-checkbox v-model="selectAll" v-on="on" class="text-center" @click="selectAllItems" />
              </template>
              <span>Seleccionar todos</span>
            </v-tooltip>
          </template>

          <template v-slot:group.header="{ items, isOpen, toggle, group }">
            <!-- Personaliza el encabezado de grupo aquí -->
            <v-chip small label class="my-2" @click="toggle">
              <v-icon small left>
                {{ isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
              </v-icon>
              {{ group }}
            </v-chip>


            <!-- {{ items[0].country }} ({{ items.length }} elementos) -->
          </template>

          <template v-for="header in headers" v-slot:[`item.${header.value}`]="{ item }">
            <slot :name="header.value" :item="item">
              {{ getItemValue(item, header.value) }}
            </slot>
          </template>

          <template v-slot:no-data>
            <!-- este vendria a ser el campo de personalizacion del chip que aparece dentro de la tabla cuando no hay datos por mostrar
            esto estandariza el tamaño minimo cuando no hay data en la tabla, consta que aun falta estandarizar el tamaño de la tabla cuando solo 
            hay un dato , pero como no fue requerimiento no habria problema -->
            <div style="height: 320px" class="d-flex justify-center align-center">
              <span>
                {{ noResultsText ? 'Sin registros guardados' : noResultsText }}
              </span>
            </div>
          </template>
          <template v-slot:no-results>
            <div class="d-flex justify-center  align-center" style="height: 320px">
              Sin datos encontrados correspondientes a su busqueda
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>



export default {

  props: {
    whitSearch: Boolean,
    itemkey: String,
    className: String,
    groupBy: [String, Array],
    sortBy: [String, Array],
    sortDesc: Array,
    headers: Array,
    dense: Boolean,
    items: Array,
    whitSelect: Boolean,
    search: String,
    loading: Boolean,
    rowsPerPageText: String,
    noResultsText: {
      type: String,
      default: "Sin registros guardados",
    },
    value: {
      type: Array,
      default: () => [],
    },

    placeholderTextsearch: String,
  },
  data() {

    return {
      selectedItems: this.value,
      selectAll: false,
      searchValue: this.search,
      groupedBy: true,

    };
  },
  methods: {
    // este funcion no tocar , entra en los values de los items e identifica si es un objeto array para poder colocarlo dentro del valor por defecto de la tabla que va
    // relacionado al campo value de la tabl
    getItemValue(item, headerValue) {
      const keys = headerValue.split(".");
      let currentValue = item;

      for (let key of keys) {
        if (currentValue === undefined) {
          return "";
        }

        if (key.endsWith("]")) {
          const arrayIndexMatch = key.match(/(.*)\[(\d+)\]/);
          if (arrayIndexMatch) {
            key = arrayIndexMatch[1];
            const index = arrayIndexMatch[2];
            currentValue = currentValue[key]
              ? currentValue[key][index]
              : undefined;
          }
        } else {
          currentValue = currentValue[key];
        }
      }

      return currentValue;
    },
    toggleGrouping() {
      this.groupedBy = !this.groupedBy; // Invertir el estado
    },

    selectAllItems() {
      if (this.selectAll) {
        this.selectedItems = [...this.items]; // Seleccionar todos los elementos
      } else {
        this.selectedItems = [];
      }
    },

  },

  computed: {
    computedSearch: {
      get() {
        return this.search;
      },
      set(value) {
        // Emitir un evento para notificar al componente padre sobre el cambio
        this.$emit('update:search', value);
      },
    },
    headerMayuscula() {
      // Solo recibe el objeto headers y retorna una copia la propiedad
      // text transformada a mayuscula
      // para usarse en los encabezados de las tablas
      const newH = this.headers.map(headerOBJ => {
        return {
          ...headerOBJ,
          text: headerOBJ.text.toUpperCase()
        }
      })
      return newH
    }

  },


  watch: {
    selectedItems(newValue) {

      this.selectAll = this.selectedItems.length === this.items.length;
      this.$emit("input", newValue);
    },
    searchValue(newValue) {
      this.$emit('update:search', newValue);
    },
  },
};
</script>

<!-- esta clase vendria a ser la encargada de que la primera columna sea estatica , si  me preguntas pos diria que era mejor el por defecto de vuetify
pero  bueno asi me lo pidieron y  chamba es chamba   -->

<style lang="sass">
.v-data-table
  overflow-x: auto


.my-sticky-column-table
  thead tr:first-child th:first-child
    /* bg color is important for th; just specify one */
    background-color: #E0E0E0

  td:first-child
    background-color: #fff

  th:first-child,
  td:first-child
    position: sticky
    left: 0
    z-index: 1
</style>
